import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { Pagination, StatusCode } from '../constants';
import { Observable } from 'rxjs';
import { ResponseResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})

export class ExportService {
  constructor(private commonService: CommonService) { }

  getTotalReport(id): Observable<ResponseResult> {
    return this.commonService.getById(`export/print-qrcode/${id}`);
  }

  getTotalReportDetail(id): Observable<ResponseResult> {
    return this.commonService.getById(`export/print-qrcode-detail/${id}`);
  }

  getProductRating(
    cateId: number,
    fromDate: any = null,
    toDate: any = null,
    wardId: number = null,
    districtId: number = null,
    provinceId: number = null,
    filter: any = null,
    pageIndex: number = Pagination.PageIndex,
    pageSize: number = 1000
  ): Observable<ResponseResult> {
    let url = `export/${cateId}/download-product-rating?cateId=${cateId}`;
    if (fromDate) {
      url = url + `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    if (wardId) {
      url = url + `&wardId=${wardId}`;
    }
    if (districtId) {
      url = url + `&districtId=${districtId}`;
    }
    if (provinceId) {
      url = url + `&provinceId=${provinceId}`;
    }
    if (filter) {
      url = url + `&filter=${filter}`;
    }
    return this.commonService.getAll( url, true, pageIndex, pageSize);
  }

  getFarmerReport(model:any ={}): Observable<ResponseResult> {
    let url = `export/download-farmer-report`;
    return this.commonService.getDataByBody( url, model);
  }

  getSelectedFarmerReport(model:any ={}): Observable<ResponseResult> {
    let url = `export/download-farmer-report-selected`;
    return this.commonService.getDataByBody( url, model);
  }

  getMaterialReport(model:any ={}): Observable<ResponseResult> {
    let url = `export/download-material-report`;
    return this.commonService.getDataByBody( url, model);
  }

  getFermentationReport(model:any ={}): Observable<ResponseResult> {
    let url = `export/download-fermentation-report`;
    return this.commonService.getDataByBody( url, model);
  }
  
  getTraceContractReport(model:any ={}): Observable<ResponseResult> {
    let url = `export/download-trace-contract-report`;
    return this.commonService.getDataByBody( url, model);
  }
}
